import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectVendorData } from '../vendormasters/store/selectors';
import { Eye } from 'react-feather';
import { OverlayTrigger, Tooltip, Modal, Button } from 'react-bootstrap';
import { ReceivingShipmentService } from '../../service/api/receiving-shipment-service';
import { useNavigate } from 'react-router-dom';

const POAddEditForm = ({ data, shipmentContext }) => {
  const vendors = useSelector(selectVendorData) || [];
  const vendor = vendors.find(v => v.id === data?.VendorID);
  const navigate = useNavigate();

  // Shipment modal state
  const [showShipmentsModal, setShowShipmentsModal] = useState(false);
  const [shipments, setShipments] = useState([]);
  const [loadingShipments, setLoadingShipments] = useState(false);



  // Placeholder handler for View Shipments
  const onViewShipments = async () => {
    setShowShipmentsModal(true);
    setLoadingShipments(true);
    try {
      const response = await ReceivingShipmentService.getShipmentsByPOQuery({
        POId: data?.poReceivingID,
        POItemId: 0,
        POReleaseId: 0
      });
      if (response.status === 200 && Array.isArray(response.response)) {
        setShipments(response.response);
      } else {
        setShipments([]);
      }
    } catch (error) {
      setShipments([]);
    } finally {
      setLoadingShipments(false);
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-lg-2 col-md-3 col-sm-6">
          <div className="input-blocks">
            <label>PO Number</label>
            <div className="form-control-plaintext">{data?.poNumber}</div>
          </div>
        </div>
        <div className="col-lg-2 col-md-3 col-sm-6">
          <div className="input-blocks">
            <label>Vendor/Customer</label>
            <div className="form-control-plaintext">{data?.vendorName}</div>
          </div>
        </div>
        <div className="col-lg-2 col-md-3 col-sm-6 d-flex align-items-center">
          <div className="input-blocks">
            <label>View Shipments</label>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="view-shipments-tooltip">View Shipments</Tooltip>}
            >
              <button
                className="btn btn-light btn-sm d-flex align-items-center"
                style={{ border: '1px solid #ddd' }}
                onClick={onViewShipments}
              >
                <Eye size={16} />
              </button>
            </OverlayTrigger>
          </div>
        </div>
      </div>
      {/* Shared Shipments Modal */}
      <Modal show={showShipmentsModal} onHide={() => setShowShipmentsModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Shipments</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingShipments ? (
            <div className="text-center p-4">Loading shipments...</div>
          ) : shipments.length === 0 ? (
            <div className="text-center p-4">No shipments found.</div>
          ) : (
            <div className="table-responsive">

              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Shipment Number</th>
                    <th>Date</th>
                    <th>Status</th>
                    {shipmentContext?.type !== 'po' && <th>Received Quantity</th>}
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {shipments.map(s => (
                    <tr key={s.receivingShipmentID}>
                      <td>{s.shipmentNumber}</td>
                      <td>{s.shipmentDate}</td>
                      <td>{s.status || '-'}</td>
                      {shipmentContext?.type !== 'po' && <td>{s.receivedQuantity ?? '-'}</td>}
                      <td>
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => navigate(`/mappings?shipmentId=${s.receivingShipmentID}`)}
                        >
                          Go to Shipment
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowShipmentsModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

POAddEditForm.propTypes = {
  data: PropTypes.object,
  shipmentContext: PropTypes.object,
};

export default POAddEditForm;
